import { GlDisclosureDropdown, GlDisclosureDropdownItem, GlDisclosureDropdownGroup, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import CsvImportExportButtons from './csv_import_export_buttons.vue?vue3';
export default {
    name: 'MoreActionsDropdown',
    components: {
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        GlDisclosureDropdownGroup,
        CsvImportExportButtons
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    provide: {
        showExportButton: true
    },
    inject: {
        isSignedIn: {},
        isProject: {
            default: true
        },
        rssUrl: {}
    },
    props: {
        count: {
            type: Number,
            required: true
        },
        exportVariables: {
            type: Object,
            required: false,
            default: ()=>({})
        }
    },
    data () {
        return {
            isDropdownVisible: false
        };
    },
    computed: {
        moreActionsTooltip () {
            return this.isDropdownVisible ? '' : this.$options.i18n.toggleText;
        },
        subscribeToRSSItem () {
            return {
                text: this.$options.i18n.subscribeToRSS,
                href: this.rssUrl
            };
        }
    },
    methods: {
        showDropdown () {
            this.isDropdownVisible = true;
        },
        hideDropdown () {
            this.isDropdownVisible = false;
        }
    },
    i18n: {
        toggleText: __('Actions'),
        subscribeToRSS: __('Subscribe to RSS feed')
    }
};
